import { GetStaticPaths, GetStaticProps } from 'next'

import query, { PAGES } from './queries'
import ROUTE from './route'

import initApollo, { API } from 'src/api'

export const getStaticPaths: GetStaticPaths = async () => {
  const client = initApollo({})

  const { data } = await client.query<API.HallOfFamer_pages>({
    query: PAGES,
  })

  const paths = data.hallOfFamers?.nodes?.map((item) => ROUTE.path({ slug: item.slug })) || []

  return { paths, fallback: false }
}

export type Props = API.HallOfFamer_hallOfFamer & {
  more: API.HallOfFamer_hallOfFamer_previous_previous[]
}

export const getStaticProps: GetStaticProps<Props, { slug: string }> = async ({ params }) => {
  const client = initApollo({})

  const { data } = await client.query<API.HallOfFamer, API.HallOfFamerVariables>({
    query,
    variables: {
      slug: params!.slug,
    },
  })

  if (!data.hallOfFamer) {
    throw new Error()
  }

  return {
    props: {
      key: data.hallOfFamer.id,
      ...data.hallOfFamer,
      more: [
        data.hallOfFamer.previous!,
        data.hallOfFamer.previous?.previous!,
        data.hallOfFamer.next!,
        data.hallOfFamer.next?.next!,
      ]
        .filter(Boolean)
        .slice(0, 3),
    },
  }
}
